<script>
import { euroCouponsThirdpartyMethods, } from '@state/helpers'


export default {
  name: 'EuroCouponsThirdpartyDelete',
  components: {},
  props: {
    instanceJson: {
      type: Object,
      required: true,
    },
    oncomplete: { 
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      toDelete: {}
    }
  },
  computed: {},

  mounted: function () {
    let context = this
    if (context.instanceJson.url) {
      context.toDelete = {
        ...context.instanceJson,
      }
      context.getObject()
    } else {
      context.oncancel()
    }
  },

  methods: {
    ...euroCouponsThirdpartyMethods,

    getObject() {
      let context = this
      const promise = context.fetchEuroCouponsThirdpartyDetail(context.toDelete.url)
      return promise
        .then((data) => {
          context.toDelete = { ...data }
          context.loading = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          context.loading = false
          context.oncancel()
        })
    },

    deleteObject() {
      let context = this
      context.submitting = true
      const promise = context.deleteEuroCouponsThirdparty(context.toDelete.url)
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            `${context.$t('thirdparty')} ${context.$t('eliminated')} ${context.$t('correctly')}`
          )
          setTimeout(() => {
            context.submitting = false
            context.oncomplete()
          }, 1000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },
  },

}
</script>

<template>
  <b-modal
    id="delete-modal"
    v-model="modalShow"
    :title="`${ $t('delete') } ${ $t('thirdparty') }`"
    ok-title="Delete"
    ok-variant="danger"
    @hidden="oncancel"
    @ok.prevent="deleteObject"
    >
      <b-container class="p-0">
        <b-row v-if="loading">
          <b-col md="12">
            <div class="text-center">
              <b-spinner
                label="Spinning"
                style="color: #195db2; width: 4rem; height: 4rem"
              ></b-spinner>
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col md="12">
            <p class="text-center">
              {{ $t('are_sure_delete') }} el {{ $t('thirdparty') }} {{ toDelete.name || toDelete.id }}? <br>
              Esto también eliminara los usuarios asociados a este Aliado.

            </p>
          </b-col>
        </b-row>
      </b-container>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button 
          size="sm"
          variant="outline-primary rounded shadow-sm"
          :disabled="submitting"
          @click="cancel">
          Cancelar
        </b-button>
        <b-button
          size="sm"
          variant="danger rounded shadow-sm"
          :disabled="submitting"
          @click="ok">
          <span
            v-if="!submitting"
            >
            {{ $t('delete') }}
          </span>
          <b-spinner
            v-if="submitting"
            small
            label="Spinning"
            variant="light"
            >
          </b-spinner>
        </b-button>
      </template>

  </b-modal>
</template>
<style lang="scss">
</style>